import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, delay, toObservable } from "keautils";
import { observeResource } from "kea-resource";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { ServiciosAdicionalesView, validarServiciosAdicionales } from "../adicionales/view";
import { DestinoSucursal } from "../destinosucursal";
import { validarCoberturaEAD, validarFolioPP, arreglarGuiaPP, arreglarGuiaPPNuevo } from "../logic";
import { EsZonaExtRx } from "../eszonaext";
import { FolioGuiaPP } from "../guiapp";

export interface Params {
    asignarSeguroDefault: boolean;
    puedeModificarRecoleccion: boolean;
    session: models.Session | null;
    BanderaEscribir: boolean;
    BanderaDesabilitado: boolean;
}

type Entity = models.PaqueteDocumentacion;
export interface Props extends kea.ModalProps<Entity, boolean, Params> {
}


export function validar(x: Entity) {

    const rules: validation.Rules<Entity> = {
        Cantidad: validation.and(validation.required, validation.integer, validation.range(1)),
        Peso: validation.and(validation.required, validation.rangeEx(0)),
        Alto: validation.and(validation.required, validation.rangeEx(0)),
        Ancho: validation.and(validation.required, validation.rangeEx(0)),
        Largo: validation.and(validation.required, validation.rangeEx(0)),
        IdDireccionDestino: validation.required,
        IdContenidoPaquete: validation.required,
        IdDescripcionPaquete: validation.required,
        IdSucursalDestino: validation.required,
        ServiciosAdicionales: (x, key) => validation.subrule<models.ServiciosAdicionales, Entity>(y => validarServiciosAdicionales(y, x))(x, key),
        FolioGuiaPP: x => validarFolioPP(x.FolioGuiaPP, models.TipoServicio.Paquete)
    };
    return validation.getErrors(rules, x);
}



/**
* Modal de edición para un PaqueteDocumentacion
*/
export class PaqueteDocumentacionEdit extends React.PureComponent<Props> {

    value = (props: Props) => props.value;
    puedeModificarRecoleccion = (props: Props) => props.params.puedeModificarRecoleccion;
    asignarSeguroDefault = (props: Props) => props.params.asignarSeguroDefault;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));

    esFolioGuiaPP = (props: Props) => !!props.value.FolioGuiaPP;
    getField = formfields(() => this.props, () => this.errors(this.props));

    onFolioPPChange = async (folioPP: string) => {
        const value = this.value(this.props);
        const cambio: Partial<Entity> = { FolioGuiaPP: folioPP };
        const nuevo = { ...value, ...cambio } as Entity;
        var next = await arreglarGuiaPPNuevo(nuevo, models.TipoServicio.Paquete);
        this.props.onChange(next);
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    private onHandleDescripcionPaqueteChange = async (idDescripcionPaquete: number) => {
        const viejo = this.props.value;
        const cambioPaquete: Partial<Entity> = { IdDescripcionPaquete: idDescripcionPaquete, };
        this.props.onChange({ ...viejo, ...cambioPaquete });

        var descripcionPaquete = await resources.DescripcionPaquete.getMemo(idDescripcionPaquete);
        const nuevo = this.props.value;
        const idContenidoPaquete = nuevo.IdContenidoPaquete;

        const contiene = descripcionPaquete.ContenidosPaquetes.filter(x => x.IdContenidoPaquete == idContenidoPaquete).length > 0;
        const cambio: Partial<Entity> = {
            Peso: descripcionPaquete.Peso || this.props.value.Peso,
            Largo: descripcionPaquete.Largo || this.props.value.Largo,
            Alto: descripcionPaquete.Alto || this.props.value.Alto,
            Ancho: descripcionPaquete.Ancho || this.props.value.Ancho,
            IdContenidoPaquete: contiene || !descripcionPaquete.VerSoloContenidosPaquetesRelacionados ? idContenidoPaquete : undefined
        };
        this.props.onChange({ ...nuevo, ...cambio });
    }

    IdDescripcionPaquete = (props: Props) => props.value.IdDescripcionPaquete || null;

    private DescripcionPaquete = createSelectorRx(this.IdDescripcionPaquete, id => {
        const ret = id != null ? observeResource(resources.DescripcionPaquete.getMemo, id) : null;
        return toObservable(ret);
    });

    itemsUsados = createSelectorRx(this.DescripcionPaquete, resources.ContenidoPaquete.query, (DescripcionPaquete, items) =>
        DescripcionPaquete != null && DescripcionPaquete.VerSoloContenidosPaquetesRelacionados ?
            items.filter(x => DescripcionPaquete.ContenidosPaquetes.map(x => x.IdContenidoPaquete).indexOf(x.IdRegistro) != -1)
            : items
    );

    servAdic = (x: Props) => x.value.ServiciosAdicionales;
    idDireccionDestino = (x: Props) => x.value.IdDireccionDestino;
    idSucursalDestino = (x: Props) => x.value.IdSucursalDestino;
    esZonaExtendida = createSelectorRx(
        this.servAdic,
        this.idSucursalDestino,
        this.idDireccionDestino,
        (servAdic, idSucDest, idDireccionDestino) =>
            observeResource(resources.Documentacion.EsZonaExtendida, servAdic, idSucDest, idDireccionDestino));

    componentDidMount() {
        document.addEventListener('contextmenu', (e) => {                    
            if( !this.props.params.session?.CapturarPesoManualEnDocumentacion && window.location.hash === "#/operativa/documentar" )
            {e.preventDefault();}          
        });

        document.addEventListener('keydown', (e) => {       
            if( !this.props.params.session?.CapturarPesoManualEnDocumentacion && e.ctrlKey && window.location.hash === "#/operativa/documentar" )
            {
                e.preventDefault();
            }    
            
            if( !this.props.params.session?.CapturarPesoManualEnDocumentacion && e.keyCode === 113  && window.location.hash === "#/operativa/documentar" )
            {
                this.props.params.BanderaEscribir = true;
                
                this.actualizarProps()

                
                this.forceUpdate()
            } 
        });
      };

    actualizarProps = () =>{
        const nuevo = this.props.value;
                const cambio: Partial<Entity> = 
                {
                    Peso:  undefined,
                    Largo: nuevo.Largo || undefined,
                    Alto: nuevo.Alto || undefined,
                    Ancho: nuevo.Ancho || undefined,
                    IdContenidoPaquete: nuevo.IdContenidoPaquete
                }
    
                this.props.onChange({ ...nuevo, ...cambio });
    
                this.forceUpdate()
    }

    LimpiarPeso = () => {
        this.props.params.BanderaDesabilitado = false;
        this.actualizarProps()
    };

    ActualizarInputPesoNuevo = ( event ) => {

        var valor = event.target.value
        var ElementoPeso = event.target 
        
        if( valor.includes("k") || valor.includes("K") )
        {
            valor = valor.replace("k", '')
            valor = valor.replace("K", '')
            
            //event.target.value = valor
            this.props.value.Peso = valor;
            ElementoPeso.disabled = true
            this.props.params.BanderaEscribir = false;
        }
        
    };

    ActualizarInputPesoNuevo2 = ( event ) => {
        if(this.props.params.BanderaEscribir)
        {
            if( (event+"").includes("k") || (event+"").includes("K") )
            {
                this.props.params.BanderaEscribir = false;
                let eventStr = (event+"").replace("k", '')
                eventStr = eventStr.replace("K", '')
                eventStr = eventStr.replace("g", '')
                eventStr = eventStr.replace("G", '')
                this.props.value.Peso = Number(eventStr);
                this.forceUpdate()
                const nuevo = this.props.value;
                const cambio: Partial<Entity> = 
                {
                    Peso:  Number(eventStr),
                    Largo: nuevo.Largo || undefined,
                    Alto: nuevo.Alto || undefined,
                    Ancho: nuevo.Ancho || undefined,
                    IdContenidoPaquete: nuevo.IdContenidoPaquete
                }

                this.props.onChange({ ...nuevo, ...cambio });

                const div1 = document.getElementById( "div1" );
                const div2 = document.getElementById( "div2" );

                if (div1 === null) {
                    alert('oops');
                  } else {
                    div1.hidden = !div1.hidden 
                  }

                if (div2 === null) {
                alert('oops');
                } else {
                div2.hidden = !div2.hidden 
                }

                setTimeout(() => {
                    this.props.params.BanderaDesabilitado = true;
                    this.forceUpdate()
                  }, 250);
                
            }
            
        }
        else
        {
            const nuevo = this.props.value;
            const cambio: Partial<Entity> = 
            {
                Peso:  undefined,
                Largo: nuevo.Largo || undefined,
                Alto: nuevo.Alto || undefined,
                Ancho: nuevo.Ancho || undefined,
                IdContenidoPaquete: nuevo.IdContenidoPaquete
            }

            this.props.onChange({ ...nuevo, ...cambio });

            this.forceUpdate()
        }
    };

    render() {
        const puedeModificarRecoleccion = this.puedeModificarRecoleccion(this.props);
        const asignarSeguroDefault = this.asignarSeguroDefault(this.props);
        const itemsUsados = this.itemsUsados(this.props);
        const esFolioGuiaPP = this.esFolioGuiaPP(this.props);

        const value = this.props.value;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const NumberField = getField(kea.Number);
        const Check = getField(kea.Checkbox);
        const ServicioAdicional = getField(ServiciosAdicionalesView);
        const Descripcion = getField(selectores.DescripcionPaquete);
        const Contenido = getField(selectores.ContenidoPaquete);
        const Button = getField(kea.Button);
        const hasError = this.hasError(this.props);
        const esZonaExtendida = this.esZonaExtendida(this.props);
        const GuiaPP = getField(FolioGuiaPP);
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Paquete"
            >

                {kea.autogrid(6, [
                    <div>
                        <kea.Panel title="General">
                            {kea.autogrid(6, [
                                <Descripcion field="IdDescripcionPaquete" label="Descripción paquete" onChange={this.onHandleDescripcionPaqueteChange} />,
                                <Contenido field="IdContenidoPaquete" label="Contenido paquete" items={itemsUsados} />,
                                <NumberField field="Cantidad" readonly={esFolioGuiaPP} />,

                                ,
                                this.props.params.session?.CapturarPesoManualEnDocumentacion ?
                                <NumberField field="Peso" label="Peso (kg)"  />
                                :
                                
                                    <div className="row" >
                                        
                                        <div className="col-xs-9">
                                            <div id="div1" hidden={false} ><Text field="Peso"  label="Peso (kg)" readonly={ this.props.params.BanderaDesabilitado  } onChange={this.ActualizarInputPesoNuevo2} /></div>
                                            <div id="div2" hidden={true} ><Text field="Peso"  label="Peso (kg)" readonly={ this.props.params.BanderaDesabilitado  } onChange={this.ActualizarInputPesoNuevo2} /></div>
                                        </div>
                                        <div className="col-xs-3">
                                            <kea.Button iconClass={fa("paint-brush")} onClick={this.LimpiarPeso} ></kea.Button>
                                        </div>
                                        
                                    </div>
                                
                                ,
                                <Text field="Observaciones"  />,
                                <GuiaPP field="FolioGuiaPP" label="Guia PP" session={this.props.params.session} onChange={this.onFolioPPChange} />
                            ])}
                        </kea.Panel>
                        <EsZonaExtRx value={esZonaExtendida} />

                        <ServicioAdicional field="ServiciosAdicionales" tipo="paquete" servicio={value} puedeModificarRecoleccion={puedeModificarRecoleccion} esFolioGuiaPP={esFolioGuiaPP} asignarSeguroDefault={asignarSeguroDefault} />
                    </div>,
                    <div>
                        <kea.Panel title="Volumen" iconClass={fa("cube")} >
                            {kea.autogrid(4, [
                                <NumberField field="Largo" label="Largo (cm)" />,
                                <NumberField field="Alto" label="Alto (cm)" />,
                                <NumberField field="Ancho" label="Ancho (cm)" />,
                            ])}
                        </kea.Panel>
                        <DestinoSucursal value={this.props.value} onChange={this.props.onChange} />
                    </div>
                    ,
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/paquetes/edit.tsx